var appendElementAsLastChildOfBody = function appendElementAsLastChildOfBody(element) {
  return document.body.insertBefore(element, document.body.lastElementChild.nextElementSibling);
};

export { appendElementAsLastChildOfBody };